export default {
  //* tryLogin ---------------------------------------------------------------------------------------------------------------

  async tryLogin({ commit, rootGetters }, payload) {
    var token = localStorage.getItem("token");
    var user = localStorage.getItem("user");
    var base_address = rootGetters["settings/getBaseAddress"];
    var exitStatus = 0;
    if (token && user && token != null) {
      commit("auth", { user: user, token: token });
    } else {
      try {
        var response = await fetch(base_address + "/users/login", {
          method: "POST",
          body: JSON.stringify({
            email: payload.email,
            password: payload.psw,
          }),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Credentials": true,
            "Access-Control-Allow-Origin": "*",
            Accept: "application/json",
          },
          mode: "cors", // no-cors, *cors, same-origin
        });
        if (response.ok) {
          exitStatus = 200;
          response = await response.json();
          commit("auth", {
            token: response.token,
            user: JSON.stringify(response.user),
          });
        } else {
          exitStatus = 400;
        }
        return exitStatus;
      } catch (e) {
        console.log(e);
      }
    }
  },

  //* loadUserParameters ---------------------------------------------------------------------------------------------------------------

  async loadUserParameters({ commit, rootGetters }, payload) {
    var token = localStorage.getItem("token");
    var user = localStorage.getItem("user");
    var base_address = rootGetters["settings/getBaseAddress"];
    var exitStatus = 0;
    var response = await fetch(base_address + "/users/loadUserParameters", {
      method: "POST",
      body: JSON.stringify({
        email: payload.email,
      }),
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
      },
      mode: "cors", // no-cors, *cors, same-origin
    });
    if (response.ok) {
      exitStatus = 200;
      response = await response.json();
      // console.log(response)
      commit("setParameters", {
        parameters: response.parameters,
      });
      return response;
    } else {
      exitStatus = 400;
    }
  },

  //* showDashboard ---------------------------------------------------------------------------------------------------------------

  async showDashboard({ commit, rootGetters }, payload) {
    var token = localStorage.getItem("token");
    var user = localStorage.getItem("user");
    var base_address = rootGetters["settings/getBaseAddress"];
    var exitStatus = 0;
    var response = await fetch(base_address + "/users/showDashboard", {
      method: "POST",
      body: JSON.stringify({
        email: payload.email,
      }),
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
      },
      mode: "cors", // no-cors, *cors, same-origin
    });
    if (response.ok) {
      exitStatus = 200;
      response = await response.json();
      // console.log(response)
      return response;
    } else {
      exitStatus = 400;
    }
  },

  //* tryLogToken ---------------------------------------------------------------------------------------------------------------

  async tryLogToken({ commit, rootGetters }, payload) {
    var base_address = rootGetters["settings/getBaseAddress"];
    var exitStatus = 0;
    try {
      var response = await fetch(base_address + "/users/loginToken", {
        method: "POST",
        body: JSON.stringify({
          uuid: payload.token,
        }),
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
        },
        mode: "cors", // no-cors, *cors, same-origin
      });
      if (response.ok) {
        exitStatus = 200;
        response = await response.json();
        commit("auth", {
          token: response.token,
          user: JSON.stringify(response.user),
        });
      } else {
        exitStatus = 400;
      }
      return exitStatus;
    } catch (e) {
      console.log(e);
    }
  },

  //* logout ---------------------------------------------------------------------------------------------------------------

  async logout({ rootGetters, getters, commit }) {
    var base_address = rootGetters["settings/getBaseAddress"];
    var token = getters["getToken"];
    token = "Bearer " + token;
    await fetch(base_address + "/users/logout", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: token,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).then((response) => {
      if (response.ok) {
        commit("setToken", "");
        commit("setUser", "");
        localStorage.clear();
      }
    });
  },

  //* getToken ---------------------------------------------------------------------------------------------------------------

  async getToken(context) {
    if (!context.state.token || context.state.token === "") {
      const tok = localStorage.getItem("token") || "";
      context.commit("setToken", tok);
    }
    return context.getters["getToken"];
  },

  //* loadPackLevel ---------------------------------------------------------------------------------------------------------------

  async loadPackLevel({ dispatch, rootGetters }) {
    const isAuth = await dispatch("isAuth");
    var packLevel = null;
    if (isAuth) {
      var user = rootGetters["auth/getUser"];
      //! un po pericoloso qua !
      while (!(user instanceof Object)) {
        user = JSON.parse(user);
      }
      if (window.location.hostname == "localhost") {
        packLevel = 10;
      } else if (user && "packLevel" in user) {
        packLevel = user.packLevel;
      } else {
        packLevel = 0;
      }
    }

    localStorage.setItem("packLevel", packLevel);
    return packLevel;
  },

  //* isAuth ---------------------------------------------------------------------------------------------------------------

  isAuth({ getters, commit }) {
    if (getters["getToken"]) {
      var usr = localStorage.getItem("user");
      commit("setUser", usr);
      commit("setAuth", true);
    } else {
      commit("setAuth", false);
    }
    return getters["isAuth"];
  },

  //* addUser ---------------------------------------------------------------------------------------------------------------

  async addUser({ rootGetters }, payload) {
    var token = localStorage.getItem("token");
    var base_address = rootGetters["settings/getBaseAddress"];
    var exitStatus = 200;
    var response = await fetch(base_address + "/users", {
      method: "POST",
      body: JSON.stringify({
        email: payload.email,
        password: payload.psw,
        camping: payload.campeggio,
        name: payload.email,
      }),
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    if (!response.ok) {
      exitStatus = 400;
    }
    return exitStatus;
  },

  //* getCampings ---------------------------------------------------------------------------------------------------------------

  async getCampings({ rootGetters, commit }) {
    var token = localStorage.getItem("token");
    var base_address = rootGetters["settings/getBaseAddress"];
    var exitStatus = 200;
    if (!token) {
      return;
    }
    try {
      await fetch(base_address + "/getCamping/all", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
        mode: "cors", // no-cors, *cors, same-origin
      }).then((response) => {
        if (response.ok) {
          exitStatus = 200;
          response.json().then((data) => commit("setCampings", data));
        } else {
          exitStatus = 400;
          throw new Error();
        }
      });
    } catch (e) {
      console.log(e);
    }
    return exitStatus;
  },

  //* getCamping ---------------------------------------------------------------------------------------------------------------

  async getCamping({ rootGetters, commit }, payload) {
    var base_address = rootGetters["settings/getBaseAddress"];
    var exitStatus = 200;
    // console.log(payload)
    try {
      await fetch(base_address + "/getCamping/" + payload, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
        },
        mode: "cors", // no-cors, *cors, same-origin
      }).then(async (response) => {
        // console.log(response)
        if (response.status === 200) {
          await response.json().then(async (data) => {await commit("setCamping", data)});
        } else {
          exitStatus = 400;
          throw new Error();
        }
      });
    } catch (e) {
      console.log(e);
    }
    return exitStatus;
  },

  //* getScontoSoloSuUnita ---------------------------------------------------------------------------------------------------------------

  async getScontoSoloSuUnita({ rootGetters, commit }) {
    var token = localStorage.getItem("token");
    var base_address = rootGetters["settings/getBaseAddress"];
    var exitStatus = 200;
    if (!token) {
      return;
    }
    try {
      await fetch(base_address + "/getScontoSoloSuUnita", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
        mode: "cors", // no-cors, *cors, same-origin
      }).then((response) => {
        if (response.ok) {
          exitStatus = 200;
          // console.log(response)
          response
            .json()
            .then((data) => commit("setScontoSoloSuUnita", data[0]));
        } else {
          exitStatus = 400;
          throw new Error();
        }
      });
    } catch (e) {
      console.log(e);
    }
    return exitStatus;
  },

  //* getUsers ---------------------------------------------------------------------------------------------------------------

  async getUsers({ rootGetters, commit }) {
    var token = localStorage.getItem("token");
    var base_address = rootGetters["settings/getBaseAddress"];
    var exitStatus = 200;
    try {
      await fetch(base_address + "/users/all", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
        mode: "cors", // no-cors, *cors, same-origin
      }).then((response) => {
        if (response.ok) {
          exitStatus = 200;
          response.json().then((data) => commit("setUsers", data));
        } else {
          exitStatus = 400;
          throw new Error();
        }
      });
    } catch (e) {
      console.log(e);
    }
    return exitStatus;
  },
};
